/**
 * Extracts the page image from the response and adds it to the list of pictures
 *
 * @param {Object[]} pictures - Current list of pictures
 * @param {Object[]} pageImages - Images scraped from the page
 * @returns A new array of pictures with the scraped page images added
 */
export function extractPageImage(pictures, pageImages) {
  if (!pageImages?.length) {
    return pictures;
  }

  const newPictures = pageImages.map((pic) => ({ ...pic, type: "scraped" }));
  return pictures.concat(newPictures);
}

/**
 * Extracts image suggestions from the response and adds them to the list of pictures
 *
 * @param {Object[]} pictures - Current list of pictures
 * @param {Object[]} suggestions - Suggested images
 * @returns A new array of pictures with the suggestions added
 */
export function extractImageSuggestions(pictures, suggestions) {
  if (!suggestions?.length) {
    return pictures;
  }

  const MAX_SUGGESTIONS = 5;

  const recentPictures = suggestions
    .slice(0, MAX_SUGGESTIONS)
    .map((pic) => ({ ...pic, type: "recent" }));

  return pictures.concat(recentPictures);
}
